import "./App.css";
import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes, useParams } from "react-router-dom";
import Navbar from "./navbar/navbar.js";
import LaunchesCalendar from "./launch_calendar/LaunchCalendar.js";
import LaunchList from "./launches/LaunchList.js";
import LaunchInformation from "./launches/LaunchInformation.js";
import VehicleList from "./vehicles/vehicleList.js";
import VehicleDetails from "./vehicles/vehicleInfo.js";
import Home from "./home/Home.js";
import FamilyInformation from "./vehicles/RocketStats.js";
import BoosterComparePage from "./vehicles/BoosterComparePage.js";
import AdditionalGraphs from "./other/AdditionalGraphs.js";
import NotFound from "./other/NotFound.js";
import ShareChart from "./share/ShareChart.js";

import "./index.css";
import "./output.css";
import "./liquid-glass.css";
import { mountLiquidGlass } from "./liquidLens.js";

const Footer = () => (
  <footer className="bt-footer">
    <div className="bt-footer-inner">
      <div className="bt-footer-brand">
        <img src="/booster-tracker.png" alt="" aria-hidden="true" />
        <div>
          <strong>Booster Tracker</strong>
          <span>Launch and reuse tracking</span>
        </div>
      </div>

      <a
        className="bt-footer-x"
        href="https://x.com/BoosterTracker"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Booster Tracker on X"
      >
        <img src="/x-logo-white.png" alt="" aria-hidden="true" />
        <span>Booster Tracker</span>
      </a>
    </div>
  </footer>
);

const FamilyInfoWrapper = () => {
  const { family } = useParams();
  return <FamilyInformation key={family} />;
};

function App() {
  React.useEffect(() => mountLiquidGlass(document.querySelector(".bt-nav-shell")), []);

  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Navbar />
      <div className="content">
          <Routes>
            <Route path="/graphs/" element={<AdditionalGraphs />} />
            <Route path="/share/:chartKey" element={<ShareChart />} />
            <Route path="/launch-calendar/" element={<LaunchesCalendar />} />
            <Route path="/launches/" element={<LaunchList />} />
            <Route path="/falcon/boosters/" element={<VehicleList type={"stage"} familyID={1} key="falcon" />} />
            <Route path="/falcon/compare/" element={<BoosterComparePage />} />
            <Route path="/falcon/booster-stats/" element={<Navigate to="/falcon/stats/?tab=boosters" replace />} />
            <Route path="/dragon/spacecraft/" element={<VehicleList type={"spacecraft"} familyID={1} key="dragon" />} />
            <Route path="/starship/boosters/" element={<VehicleList type={"stage"} familyID={2} key="superheavy" />} />
            <Route path="/starship/ships/" element={<VehicleList type={"stage"} familyID={2} key="ships" />} />
            <Route path="/pads/" element={<VehicleList type={"pad"} familyID={6579} key="pads" />} />
            <Route
              path="/recoveryzones/"
              element={<VehicleList type={"recoveryzone"} familyID={665463519} key="zones" />}
            />
            <Route path="/launch/:id/" element={<LaunchInformation />} />
            <Route path="/spacecraft/:id/" element={<VehicleDetails key="spacecraft" />} />
            <Route path="/stage/:id/" element={<VehicleDetails key="stage" />} />
            <Route path="/pad/:id/" element={<VehicleDetails key="pad" />} />
            <Route path="/recoveryzone/:id/" element={<VehicleDetails key="zone" />} />
            <Route path="/:family/stats/" element={<FamilyInfoWrapper />} />
            <Route path="/" element={<Home />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
    </Router>
  );
}

export default App;
